import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { getLogoUrl, NO_LOGO_IMAGE } from '../../utils/logo-utils';

@Component({
  selector: 'clearbit-logo',
  templateUrl: './clearbit-logo.component.html',
  styleUrls: ['./clearbit-logo.component.scss']
})
export class ClearbitLogoComponent implements OnInit, OnChanges {

  @Input() domain: unknown;
  @Input() height: number;
  @Input() width: number = 100;
  @Input() greyscale: boolean;

  private readonly defaultLogo = NO_LOGO_IMAGE;

  src: string = this.defaultLogo;

  constructor() {
  }

  ngOnInit(): void {
    this.updateImageSrc();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.domain || changes.greyscale) {
      this.updateImageSrc();
    }
  }

  updateImageSrc(): void {
    const rawValue = this.extractLogoValue(this.domain);

    if (!rawValue) {
      this.src = this.defaultLogo;
      return;
    }

    this.src = getLogoUrl(rawValue, this.width, this.greyscale);
  }

  errorHandler(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    if (!imgElement.src.endsWith(this.defaultLogo)) {
      imgElement.src = this.defaultLogo;
    }
  }

  private extractLogoValue(value: unknown): string {
    if (typeof value === 'string') {
      const trimmedValue = value.trim();
      if (!trimmedValue) return '';

      if ((trimmedValue.startsWith('{') && trimmedValue.endsWith('}')) ||
          (trimmedValue.startsWith('[') && trimmedValue.endsWith(']'))) {
        try {
          return this.extractLogoValue(JSON.parse(trimmedValue));
        } catch {
          return trimmedValue;
        }
      }

      return trimmedValue;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        const candidate = this.extractLogoValue(item);
        if (candidate) return candidate;
      }
      return '';
    }

    if (value && typeof value === 'object') {
      const record = value as Record<string, unknown>;
      for (const key of ['domain', 'website', 'url', 'href', 'value']) {
        const candidate = this.extractLogoValue(record[key]);
        if (candidate) return candidate;
      }
    }

    return '';
  }

}
